<template>
    <q-page style="background-color: #fafafa">
        <div class="flex align-center + justify-between" style="padding: 5.33vmin 14vmin 4.67vmin; border-bottom: 1px solid #e0e0e0; background-color: white">
            <div style="width: 82%">
                <span class="informTt40">{{ notify?.title }}</span>
            </div>
            <div style="width: 15%">
                <span class="dateTt30">{{ notify?.createdTs }}</span>
                <div class="barVertical" />
                <span class="dateTt30">{{ notify?.searchCount }}회</span>
            </div>
        </div>
        <div style="margin: 4.17vmin 14vmin">
            <div class="boxRounded">
                <div class="conHtml" v-html="notify?.contents" style="font-size: 1.4vw"></div>
            </div>
            <div v-if="notify?.attachFileList?.length > 0" class="attached-file">
                <h3>첨부파일</h3>
                <ul class="boxRounded file__list">
                    <template v-for="e in notify?.attachFileList" :key="e.seq">
                        <li class="file__item">
                            <template v-if="gStore?.appVersion === null">
                                <q-btn flat @click="onFileDown(e)" style="padding-left: 0">
                                    <a href="#">{{ e.originalFileName }}</a>
                                </q-btn>
                            </template>
                            <template v-if="gStore?.appVersion !== null">
                                <q-btn flat>
                                    <a :href="VUE_APP_API_URL + '/api/my-page/notice/file-download/' + e.seq + '?fineName=' + e.originalFileName" download>{{ e.originalFileName }}</a>
                                </q-btn>
                            </template>
                        </li>
                    </template>
                </ul>
            </div>
        </div>
        <div class="btn__box" style="padding-bottom: 100px">
            <CusButton :type="550" :label="`목록으로`" @onReturn="onBack" />
        </div>
    </q-page>
    <LoadingCard :is-show="isLoading" />
</template>

<script setup>
import { onMounted, ref, watch, defineProps, defineEmits } from 'vue';
import customHeader from '@/components/layouts/header/header.vue';
import { getNotice, apiGetNoticeFile } from '@/api/modules/mypage.js';
import CusButton from '@/components/widget/CusButton.vue';
import LoadingCard from '@/components/quasar/loadingCard.vue';

import { useQuasar } from 'quasar';
import { useRouter, useRoute } from 'vue-router';
import { GlobalStore } from '@/store';
import { DialogStore } from '@/store/modules/dialog';
const dStore = DialogStore();
const gStore = GlobalStore();
const router = useRouter();
const route = useRoute();
const $q = useQuasar();

const isLoading = ref(false);
const notify = ref();
const VUE_APP_API_URL = process.env.VUE_APP_API_URL;

const props = defineProps({
    seq: {
        type: Number,
        default: null,
        required: true,
    },
    isNoticeDetail: {
        type: Boolean,
        default: true,
    },
});
const emit = defineEmits(['update:isNoticeDetail']);

const getNoticeObj = async (seq) => {
    isLoading.value = true;
    const res = await getNotice(seq);
    if (res && res.status === 200) {
        notify.value = res.data.data;
        isLoading.value = false;
    }
    // console.log('--setItemData- notify.value-', notify.value);
};
onMounted(() => {
    if (props.seq) getNoticeObj(props.seq);
    // const { seq } = route.query;
});
////////////////////////////----OnClick----////////////////////////////

const onFileDown = async (e) => {
    const resultStatus = await apiGetNoticeFile(e.originalFileName, e.seq);
    if (resultStatus !== true) {
        console.error('Error-apiGetNoticeFile: ', resultStatus);
        dStore.errorMsg('관리자에게 문의하세요.');
    }
};
const onBack = () => {
    // gStore.setIsNoticeInform(true);
    // router.push('/inform');
    emit('update:isNoticeDetail', false);
};
// const onHome = () => {
//     dStore.openSelect('홈으로 이동하시겠습니까?', (val) => {
//         val && router.push('/learninghome');
//     });
// };
</script>

<style lang="scss">
.conHtml {
    overflow: hidden;
    * {
        img {
            width: 100%;
        }
    }
}

::v-deep {
    .btn {
        .q-btn--actionable.q-btn--standard:before {
            box-shadow: inherit;
        }
    }
}
.attached-file {
    margin-top: 4.67vmin;

    h3 {
        margin: 0 0px 1.17vmin;
        font-size: 1.8vw;
        font-weight: 700;
        line-height: 2.6vw;
    }

    .file {
        &__list {
            padding: 0 2vmin;
        }

        &__item {
            padding: 0.58vmin 0;

            a {
                display: inline-block;
                position: relative;
                padding: 0 1vmin 0 calc(2.4vw + 1vmin);
                font-size: 0.8vw;
                font-weight: 500;
                color: $color_positive;
                line-height: 2.4vw;

                &::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 2.4vw;
                    height: 2.4vw;
                    background: url('@/assets/images/icon/ico_download.svg') no-repeat center/ 100%;
                }
            }

            &:nth-of-type(n + 2) {
                border-top: 1px solid $color_gray_400;
            }
        }
    }
}

.boxRounded {
    margin: 0;
    padding: 5.33vmin;
}

.btn {
    width: 25%;
    max-width: 435px;
    margin: 5vmin 0;
    padding: 2.33vmin;
    border-radius: 1vmin;

    &__box {
        text-align: center;
    }

    .q-btn__content {
        .block {
            font-size: 1.2vw;
            line-height: 1.6vw;
            font-weight: 700;
        }
    }
}
.q-btn--actionable.q-btn--standard:before {
    box-shadow: inherit;
}
</style>
